var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.246,
    height: 24.863,
    viewBox: "0 0 35.246 24.863",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.481,5.745,25.161,8.99V5.1a2.6,2.6,0,0,0-2.6-2.6H3.1A2.6,2.6,0,0,0,.5,5.1V23.267a2.6,2.6,0,0,0,2.6,2.6H22.565a2.6,2.6,0,0,0,2.6-2.6V19.373l7.32,3.245a1.3,1.3,0,0,0,1.765-1.22V6.965a1.3,1.3,0,0,0-1.765-1.22h0Z",
    transform: "translate(0.25 -1.75)",
    fill: "none",
    stroke: "#f79420",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video-icon.522802e6d78fb89a0832e7e6dc2ba944.svg";
export { ForwardRef as ReactComponent };